import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from './LanguageContext';
import { getTranslation } from './translations';
import LanguageSelector from './LanguageSelector';

function PasswordResetSuccess() {
  const navigate = useNavigate();
  const { language } = useLanguage();

  return (
    <div style={{ 
      minHeight: '100vh', 
      background: '#f0f8ff',
      display: 'flex', 
      flexDirection: 'column',
      alignItems: 'center', 
      justifyContent: 'center', 
      padding: window.innerWidth <= 600 ? '20px 20px' : '40px 0',
      fontFamily: 'Nunito, Arial, sans-serif',
      position: 'relative'
    }}>
      {/* Language Selector */}
      <div style={{ position: 'absolute', top: '20px', right: '20px', zIndex: 1000 }}>
        <LanguageSelector />
      </div>
      {/* Main Title */}
      <h1 style={{
        fontSize: window.innerWidth <= 600 ? '2.5rem' : '3.5rem',
        fontWeight: 'bold',
        color: '#7c3aed',
        margin: '0 0 16px 0',
        textAlign: 'center',
        padding: window.innerWidth <= 600 ? '0 20px' : '0'
      }}>
        ShootMe
      </h1>
      
      {/* Subtitle */}
      <p style={{
        fontSize: window.innerWidth <= 600 ? '1rem' : '1.2rem',
        color: '#6b7280',
        margin: '0 0 48px 0',
        textAlign: 'center',
        maxWidth: window.innerWidth <= 600 ? '90%' : '600px',
        lineHeight: '1.6',
        padding: window.innerWidth <= 600 ? '0 20px' : '0'
      }}>
        {getTranslation('password-changed-successfully', language)}
      </p>

      <div style={{
        background: 'white',
        borderRadius: window.innerWidth <= 600 ? 16 : 20,
        boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.2)',
        maxWidth: window.innerWidth <= 600 ? '95%' : 400,
        width: window.innerWidth <= 600 ? '95%' : 400,
        padding: window.innerWidth <= 600 ? 24 : 32,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        position: 'relative',
        textAlign: 'center'
      }}>
        {/* Success Icon */}
        <div style={{
          width: 80,
          height: 80,
          borderRadius: '50%',
          background: '#10b981',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: 24
        }}>
          <svg 
            width="40" 
            height="40" 
            viewBox="0 0 24 24" 
            fill="none" 
            stroke="white" 
            strokeWidth="3" 
            strokeLinecap="round" 
            strokeLinejoin="round"
          >
            <polyline points="20,6 9,17 4,12"></polyline>
          </svg>
        </div>
        
        <h2 style={{ 
          color: '#10b981', 
          marginBottom: 16, 
          fontFamily: 'Nunito, Arial, sans-serif', 
          fontWeight: 700, 
          fontSize: window.innerWidth <= 600 ? '1.5rem' : '1.8rem'
        }}>
          {getTranslation('success', language)}!
        </h2>
        
        <p style={{
          color: '#6b7280',
          fontSize: window.innerWidth <= 600 ? '14px' : '16px',
          marginBottom: 32,
          lineHeight: '1.5'
        }}>
          {getTranslation('password-changed-message', language)}
        </p>
        
        <button 
          onClick={() => navigate('/login')}
          style={{
            width: '100%',
            padding: window.innerWidth <= 600 ? '14px 0' : '12px 0',
            borderRadius: 8,
            border: 'none',
            background: '#7c3aed',
            color: 'white',
            fontWeight: 700,
            fontSize: window.innerWidth <= 600 ? '16px' : '18px',
            letterSpacing: 1,
            boxShadow: '0 4px 12px rgba(124, 58, 237, 0.3)',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            marginBottom: 16
          }}
        >
          {getTranslation('go-to-login', language)}
        </button>
        
        <button 
          onClick={() => navigate('/')}
          style={{
            width: '100%',
            padding: window.innerWidth <= 600 ? '12px 0' : '10px 0',
            borderRadius: 8,
            border: '1px solid #7c3aed',
            background: 'transparent',
            color: '#7c3aed',
            fontWeight: 600,
            fontSize: window.innerWidth <= 600 ? '14px' : '16px',
            cursor: 'pointer',
            transition: 'all 0.3s ease'
          }}
        >
          {getTranslation('main-page', language)}
        </button>
      </div>
    </div>
  );
}

export default PasswordResetSuccess;
